import {Pipe, PipeTransform} from '@angular/core';
import {SubtitlesService} from "../core";

@Pipe({
    name: 'subtitle',
    standalone: true
})
export class SubtitlePipe implements PipeTransform {
    constructor(private subtitles: SubtitlesService) {
    }

    transform(id: number): string {
        return this.subtitles.setSubtitle(id);
    }
}
